import { render, staticRenderFns } from "./AdvertisementPaper.vue?vue&type=template&id=553babc4&scoped=true"
import script from "./AdvertisementPaper.vue?vue&type=script&lang=js"
export * from "./AdvertisementPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553babc4",
  null
  
)

export default component.exports